import translate from "src/lib/translate";
import {
  ObservationBundle,
  ObservationBundleCategory
} from "src/types/observationLaboratory";
import type { TranslationKey } from "src/types/translationKey";
import { isPatientUploadBundle } from "./resolveObservationBundleCategory";

/**
 * Builds the list-row subtitle for a bundle. A source phrase is prefixed to the
 * date only when the provenance is patient-facing:
 *   - HIE-imported (IMPORTED)              → "From your records, [date]"
 *   - patient-uploaded file (SELF_REPORTED) → "From your files, [date]"
 * Care-team uploads also resolve to SELF_REPORTED but read like a normal lab
 * (just the date + brand logo), so they get no prefix. Every other category
 * likewise shows just the date.
 */
export function resolveObservationBundleSubtitle(
  category: ObservationBundleCategory,
  date: string,
  bundle: ObservationBundle
): string {
  let key: TranslationKey | null = null;

  if (category === ObservationBundleCategory.IMPORTED) {
    key = "labResults.bundle.subtitle.fromRecords";
  } else if (
    category === ObservationBundleCategory.SELF_REPORTED &&
    isPatientUploadBundle(bundle)
  ) {
    key = "labResults.bundle.subtitle.fromFiles";
  }

  return key ? translate(key, { date }) : date;
}
